import { NgModule, inject } from '@angular/core';
import { NgxTranslateCutModule } from 'ngx-translate-cut';

import { TutorialService } from '@core/tutorial.service';
// eslint-disable-next-line no-restricted-imports
import { MaterialCoreModule } from '@material/material-core.module';

import { AnalyticsModule } from './analytics/analytics.module';
import { ApiModule } from './api/api.module';
import { DownloadService } from './download.service';
import { EventService } from './event-service/application-event.service';
import { LoadingService } from './loading.service';
import { ResponsiveService } from './responsive.service';
import { TimeFilterService } from './time-filter.service';
import { UserLoginHttpService } from './user-service/user-login.service';

@NgModule({
  imports: [MaterialCoreModule, AnalyticsModule, ApiModule, NgxTranslateCutModule.forRoot()],
  providers: [
    DownloadService,
    EventService,
    LoadingService,
    ResponsiveService,
    TimeFilterService,
    TutorialService,
    UserLoginHttpService,
  ],
})
export class CoreModule {
  constructor() {
    const otherCore = inject(CoreModule, { optional: true, skipSelf: true });

    if (otherCore) {
      throw new Error(`CoreModule can be imported only once per application
        (and never in library)`);
    }
  }
}
